import * as React from "react";
const SvgFiBrandsCreativeCommonsNc = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-creative-commons-nc_svg__a)">
      <path
        fill="#151A2D"
        d="M11.979 0q5.057 0 8.528 3.471Q23.999 6.944 24 12q0 5.058-3.429 8.421Q16.928 24 11.979 24q-4.886 0-8.443-3.557Q0 16.907 0 12q0-4.93 3.536-8.528Q7.006 0 11.979 0M2.7 8.764q-.536 1.48-.536 3.236 0 3.986 2.914 6.9 2.935 2.892 6.943 2.893 4.05 0 6.986-2.936 1.05-1.006 1.65-2.1l-4.521-2.014a3.1 3.1 0 0 1-1.146 1.854q-.91.719-2.154.825v1.843h-1.393v-1.843Q9.45 17.399 7.8 15.986l1.65-1.671q1.178 1.093 2.678 1.093.621 0 1.061-.279t.439-.921q0-.45-.321-.728zm18.836 5.807q.3-1.264.3-2.571 0-4.135-2.871-6.964-2.85-2.892-6.943-2.893-4.094 0-6.921 2.893a11.5 11.5 0 0 0-1.33 1.607L8.357 8.7a2.82 2.82 0 0 1 1.136-1.511q.836-.567 1.95-.632V4.714h1.393v1.843q1.65.085 3 1.114l-1.564 1.607q-1.007-.707-2.057-.707a2.25 2.25 0 0 0-.996.214q-.44.215-.439.728 0 .15.107.3z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-nc_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsNc;
